/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Business insurance status
 * - UNKNOWN: The quote was generated through the legacy flow, and it should be aligned by a Jove user
 * - QUOTE_START: Customer started the quote
 * - DROPOUT_BEFORE_QUOTE: User start a quote and haven't interacted for 2 hours, no price is generated
 * - QUOTED_CONFIRMING: QUOTED_CONFIRMING
 * - QUOTED: Quote has been sent - to capture all quotes including re-quotes from the same customer
 * (mark with different quote ID); account created and authenticated
 * - DROPOUT_BEFORE_PURCHASE: User dropout, not active after 2 hours, but quoted and has an account
 * - PURCHASED: The customer purchased
 * - BROKER: The insurer does not have appetite, but data captured and go to broker desk
 * - FAIL: The data is sent to the insurer but price errors out
 * - NOT_INTERESTED: An admin has marked the customer as not interested or the customer specifically expressed
 * "not interested" through email link
 * - DUPLICATED: Used to mark other quotes from the same customer after one quote is purchased or marked as NOT_INTERESTED
 */
export var QuoteStatus;

(function (QuoteStatus) {
  QuoteStatus["UNKNOWN"] = "unknown";
  QuoteStatus["QUOTE_START"] = "quote_start";
  QuoteStatus["DROPOUT_BEFORE_QUOTE"] = "dropout_before_quote";
  QuoteStatus["QUOTED_CONFIRMING"] = "quoted_confirming";
  QuoteStatus["QUOTED"] = "quoted";
  QuoteStatus["DROPOUT_BEFORE_SIGNING"] = "dropout_before_signing";
  QuoteStatus["DROPOUT_AFTER_SIGNING"] = "dropout_after_signing";
  QuoteStatus["PAYMENT_PENDING"] = "payment_pending";
  QuoteStatus["PAYMENT_PROCESSING"] = "payment_processing";
  QuoteStatus["DROPOUT_BEFORE_PURCHASE"] = "dropout_before_purchase";
  QuoteStatus["PURCHASED"] = "purchased";
  QuoteStatus["PURCHASED_NOT_SIGNED"] = "purchased_not_signed";
  QuoteStatus["PURCHASE_FAILED"] = "purchase_failed";
  QuoteStatus["SUBSCRIPTION_PAYMENT_FAILED"] = "subscription_payment_failed";
  QuoteStatus["BROKER"] = "broker";
  QuoteStatus["FAIL"] = "fail";
  QuoteStatus["DECLINED"] = "declined";
  QuoteStatus["NOT_INTERESTED"] = "not_interested";
  QuoteStatus["DUPLICATED"] = "duplicated";
  QuoteStatus["NOT_STARTED"] = "not_started";
  QuoteStatus["CANCELLED"] = "cancelled";
  QuoteStatus["IN_PROGRESS"] = "in_progress";
  QuoteStatus["SUCCESS"] = "success";
  QuoteStatus["POST_PURCHASE_LOGIN_CUSTOMER"] = "post_purchase_login_customer";
  QuoteStatus["POLICY_UPDATE_QUOTED"] = "policy_update_quoted";
  QuoteStatus["REFERRAL"] = "referral";
  QuoteStatus["PRE_PAYMENT"] = "pre_payment";
  QuoteStatus["DIRECT_DEBIT_SETUP_SUCCESS"] = "direct_debit_setup_success";
  QuoteStatus["OBTAINED"] = "obtained";
  QuoteStatus["PARTIALLY_OBTAINED"] = "partially_obtained";
})(QuoteStatus || (QuoteStatus = {}));